import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import $ from "jquery";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { loader_image } from "../_components/Imagepath";
import {  base_url,Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import AddCabranePayment from '../rawmaterialsoldecabrane/AddCabranePayment';
import { formatDistanceToNow } from 'date-fns';
import Swal from 'sweetalert2';
import { 
  MenuItem,
} from '@mui/material';
// import PropTypes from 'prop-types';

import EditCabranePayment from '../rawmaterialsoldecabrane/EditCabranePayment';
const SoldesCabranesGroupByView = () => {
  let { id } = useParams();
  console.log({id});
  console.log(id);
  const [cabraneId, setCabraneId] = useState(null);

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showmodelEdit, setshowmodelEdit] = useState(false);
  const [permission, setPermission] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [value, setValue] = useState({});
     let season_id = localStorage.getItem("season_id");

    const [formData, setFormData] = useState({
      cabrane:value.cabrane_id,
      season_id:season_id,
      start_date:'' ,
      end_date: ''
    });
useEffect(() => {
        setPermission(FindModuleById(201)); 
console.log(permission);

  axios
    .get(`/raw-materials/listing-cabrane-details/${season_id+'-'+id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        setValue(response.data.data.transprt_overview);
        
        setData(response.data.data.Solde);
        setDataa(response.data.data.payemnts_advanced);
        //setDataSituations(response.data.data.situations)
        

      }
    })
    .catch((error) => {
      console.log(error);
    });
}, [id]);


//   const categoryHandler = () => {
//     setshowCategory(true)
// } 
const handleClose=()=>{
  //setshowCategory(false)
         
  setshowmodel(false);
  
setshowmodelEdit(false);
setSelectedItemId(null)
}
  const editItem = (item)=>{
    // console.log(item);
    // if(item.raw_material_id != 0 && item.id != 0){

    // }else{
      setSelectedItemId(item);
     setshowmodelEdit("showCategory")
    // }
    
  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  const columns =
  [
 
    {
      header: 'Lot Number',
      accessorFn: (row) => `${(row.lot_number)?row.lot_number:""} `,
    },
    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
    {
      accessorKey: 'cabrane_name', //normal accessorKey
      header: 'Cabrane Name',
    },   
    
    
    {
      accessorKey: 'final_amount', //normal accessorKey
      header: 'Worker Cost',
    },
 

    {
      accessorKey: 'origin', //normal accessorKey
      header: 'origin',
    },
  

    {
      accessorKey: 'supplier_name', //normal accessorKey
      header: 'Supplier',
    },
    



   ];
   
  const columnss =
  [
 
    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },


    {
      header: 'Amount',
      accessorFn: (row) => `${(row.cost)?row.cost.toFixed(2):0} `,

    },
    {
      header: 'Payment Type',
      accessorFn: (row) => `${(row.paymenttype)?row.paymenttype.title:""} `,
    },
  
    {
      accessorKey: 'note', //normal accessorKey
      header: 'Note',
    },
    {
      header: 'Created At',
      accessorFn: (row) => `${formatDistanceToNow(new Date(row.created_at), { addSuffix: true })}`,
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDistanceToNow(new Date(row.updated_at), { addSuffix: true })}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];



   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  // Automatically update the supplier field when 
  useEffect(() => {

    if (value && value.cabrane_id) {
      setFormData(prevFormData => ({
        ...prevFormData,  // Spread the existing form data (including other fields)
        cabrane: value.cabrane_id // Update the supplier field
      }));
    }
  }, [value.cabrane_id]); 



  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formData2");
    console.log(formData);
 
    axios
    .get(`/raw-materials/listing-cabrane-new-server/${season_id+'-'+id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      params: formData, // Use `params` for GET request data
    })
    .then((response) => {
      if (response.data.code === 200) {
        setValue(response.data.data.transprt_overview);
        setData(response.data.data.Solde);
        setDataa(response.data.data.payemnts_advanced);
       // setDataSituations(response.data.data.situations)
        
      } else {
        // setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error);
    });



  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
      console.log(Input_name);   
  };


  
  const downloadPDF = (e) => {
    console.log(e);
    $("#loader-image").removeClass('loader-hide').addClass('loader-show');
let season_id = localStorage.getItem("season_id");
    axios.get("/raw-materials/listing-cabrane-pdf-new-server", {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: { season_id: season_id,cabrane: formData.cabrane, start_date: formData.start_date, end_date: formData.end_date }
    })
    .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name  =value.cabrane_name + ' '+value.start_date+ ' '+value.end_date;
        link.download = file_name+'.pdf';
        link.click();
        
        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
    });
};



  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
    
    const downloadExcel = (e) => {
      console.log(e);
          const queryString = objectToQueryString(formData);

      $("#loader-image2").removeClass('loader-hide2');
      $("#loader-image2").addClass('loader-show2');
      window.open(`${base_url}/raw-materials/listing-cabrane-excel-open?${queryString}`, '_blank');
      $("#loader-image2").addClass('loader-hide2');
      $("#loader-image2").removeClass('loader-show2');
    }

  const addForm = (supplier) => {
    console.log('add');
    console.log(supplier);
    setCabraneId(supplier);
    setshowmodel(true);
  };
 

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/soldes-cabrane/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/cabrane-situation-groupby/"+value.cabrane_id;
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Raw Material Group By Cabrane </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                          <Link to="/cabrane-situation">Cabrane Situation</Link>
                    </li>
                    <li className="breadcrumb-item active">Raw Material Group By Cabrane</li>
                  </ul>
                </div>
                <div className="col-auto">
                 
                  <button  onClick={() => addForm(id)} className="btn btn-primary">
                    <i className="fas fa-plus"></i>
                  </button>
                 
                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadPDF()}
                  >
                    <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> 
                  </button>  
                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button>   

                 

                
                </div>
              </div>
            </div>
        
              <div id="filter_inputs_div" className="card filter-card1">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
                                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>

                      <input type="hidden" name="supplier" className="form-control"  value={formData.cabrane}   />

                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
              </div>
     
           
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Group By Cabrane</h4>
                      <table className="table table-bordered">
                      <tr>
                          <th className="p-3">Cabrane Name</th>
                          <td className="p-3">
                            {value.cabrane_name ? value.cabrane_name : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Number Of Receiption</th>
                          <td className="p-3">{value.number_of_receiption}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Start Date</th>
                          <td className="p-3">{value.start_date}</td>
                        </tr>
                        <tr>
                          <th className="p-3">End Date</th>
                          <td className="p-3">{value.end_date}</td>
                        </tr>
                    
                        <tr>
                          <th className="p-3">Total Transport  Cost </th>
                          <td className="p-3">{value.sum_final_amount ? value.sum_final_amount:'0.00'} dh</td>
                        </tr>
                     
                        <tr>
                          <th className="p-3">Total Payment </th>
                          <td className="p-3">{value.sum_final_payment_1_2 ? value.sum_final_payment_1_2:'0.00'} dh</td>
                        </tr>
                     
                        <tr>
                          <th className="p-3">Open Amount</th>
                          <td className="p-3">{value.situation ? value.situation:'0.00'} dh</td>
                      </tr>
                      
                       
                      </table>
                  </div>
                </div>
              </div>
            </div>
         

            <div className="row">
              <div className="col-sm-12">
              <section className="comp-section">
                <div className="row">
              
                <div className="col-md-12">

                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Solde</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Payments</a>                                   
                        </li>     
                                   
                        </ul>
                        <div className="tab-content">
                        <div className="tab-pane show active" id="listing-groupby">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  
                                    <MaterialReactTable 
                                            columns={columns} 
                                            data={data} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            renderRowActionMenuItems={({ row }) => {
                                              if (row.original.lot_number === '') {
                                                console.log("IFFFF");
                                                console.log(row.original);
                                                return [
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                    Edit
                                                  </MenuItem>,
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ];
                                              }
                                              return null; // Return null if no actions should be displayed
                                            }}
                                          />

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane " id="listing-all">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                  
                                  <MaterialReactTable 
                                      columns={columnss} 
                                      data={dataa} 
                                      enableColumnOrdering
                                      enablePinning
                                      enableRowActions
                                      renderRowActionMenuItems={({ row }) => {
                                        if (row.original.raw_material_id !== 0) {
                                          return [
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ];
                                        } else {
                                          return [
                                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                              Edit
                                            </MenuItem>,
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ];
                                        }
                                      }}
                                    />
  
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>                                
                        </div>                             
                    </div>
                    </div> 
                </div>
                </div>
            </section>

              </div>
            </div>
          </div>
          {showmodel && (
        // <AddCabranePayment props={cabraneId} handleClose={handleClose} />
        <AddCabranePayment  props={cabraneId} show={showmodel}  handleClose={handleClose} />
      )}
          
          <EditCabranePayment  itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} />

        </div>
      </div>
    </>
  );
};
export default SoldesCabranesGroupByView;
